import * as React from 'react';
import * as cases from "./style.module.scss";
import { casesData } from "./data";
import { Modal } from "../../../../Modal";
export const Cases = () => {
  const [open, setOpen] = React.useState({ open: false, selectedItem: 0 });
  return (
    <section className={cases.cases}>
      <div className="container">
        <h2>Кейсы</h2>
        <ul>
          {
            casesData.map((elem, index) => (
              <li key={index} onClick={() => {
                setOpen({ open: true, selectedItem: index });
              }} role={"presentation"}>
                <div className={cases.header}>
                  <img src={elem.pic} alt={elem.title}/>
                </div>
                <div className={cases.content}>
                  <div>
                    <h3>{elem.title}</h3>
                    <p>{elem.desc && elem.desc}</p>
                  </div>
                  <button>Подробнее</button>
                </div>
              </li>
            ))
          }
        </ul>
      </div>

      <Modal
        open={open.open}
        onClose={() => {
          setOpen({ open: false })
        }}>
        {
          casesData.map((elem, index) => (
            open.selectedItem === index && <div key={index}>{elem.content}</div>
          ))
        }
      </Modal>
    </section>
  );
};
